import { render, staticRenderFns } from "./RecordConfiguration.vue?vue&type=template&id=21927b74&scoped=true"
import script from "./RecordConfiguration.vue?vue&type=script&lang=js"
export * from "./RecordConfiguration.vue?vue&type=script&lang=js"
import style0 from "./RecordConfiguration.vue?vue&type=style&index=0&id=21927b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21927b74",
  null
  
)

export default component.exports